import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import { UIContext } from "../shared/layout"
import Link from "../shared/link"
import Grid from "../shared/grid"
import {
  MapImage,
  Title,
  BodyText,
  ContactLink,
  DownloadIcon,
  ContentWrapper,
  DownloadLinkContainer,
  ContactUsLinkContainer,
  downloadLinkCss,
} from "./data-export.style"

const DataExport = () => {
  const {
    state: { breakpoint },
  } = useContext(UIContext)
  const {
    desktopMap,
    mobileMap,
    downloadIcon,
  } = useStaticQuery(graphql`
    query {
      desktopMap: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/exports_map_desktop.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileMap: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Mobile/exports_map_mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      downloadIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/download_button_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)
  return (
    <>
      <Grid>
        <MapImage>
          <Img
            fluid={
              breakpoint === "sm"
                ? mobileMap.childImageSharp.fluid
                : desktopMap.childImageSharp.fluid
            }
            imgStyle={{ objectFit: "cover" }}
            alt={"An example of a map created with the Mappedin Data Export"}
          />
        </MapImage>
        <Title>Mappedin Data Export</Title>
        <ContentWrapper>
          <BodyText>
            Mappedin’s GeoJSON based format provides customers with geometry and
            location data associated with a venue that is directly connected to
            the Mappedin CMS. Along with the data required for Apple's IMDF,
            this export includes nodes and paths allowing you to easily build
            wayfinding capabilities.
          </BodyText>
          <BodyText>
            This format can be used to build 2D mapping experiences or converted
            with a variety of 3D renderers, including Mappedin’s.
          </BodyText>
          <DownloadLinkContainer>
            <Link
              href={"/MVF_Demo_Files.zip"}
              download
              styleModifier={downloadLinkCss}
            >
              <DownloadIcon
                src={downloadIcon.publicURL}
                alt="A symbol representing a download action"
              />
              Download Sample File
            </Link>
          </DownloadLinkContainer>
          <ContactUsLinkContainer>
            <ContactLink to="contact-form" smooth duration={1000}>
              Contact Us
            </ContactLink>
          </ContactUsLinkContainer>
        </ContentWrapper>
      </Grid>
    </>
  )
}

export default DataExport
